export default "__VITE_ASSET__dHzF80FA__"